import Vue from 'vue';
import { apiPath } from '../constants';

const Release = Vue.resource(
  `${apiPath}/apps{/packageName}/releases{/id}{/version}{/action}{/packageToken}/`,
  {},
  {
    commit: { method: 'POST', params: { action: 'commit', version: 'v2' } },
    reviewRequest: {
      method: 'POST',
      params: { version: 'v2', action: 'review-request' },
    },
    cancelReviewRequest: {
      method: 'DELETE',
      params: { action: 'review-request' },
    },
    addPackageToRelease: { method: 'POST', params: { action: 'packages' } },
    publish: { method: 'POST', params: { action: 'publish' } },
    deactive: { method: 'POST', params: { action: 'deactivate' } },
    getUncommitted: { method: 'GET', params: { committed: '0' } },
    update: { method: 'PATCH' },
    removePackageFromRelease: {
      method: 'DELETE',
      params: { action: 'packages' },
    },
    updateStagedRollout: {
      method: 'PATCH',
      params: { action: 'stagerollout' },
    },
    getCpuArchitectures: {
      method: 'GET',
      url: `${apiPath}/architectures/`,
    },
    updatePackageArchitecture: {
      method: 'PUT',
      url: `${apiPath}/apps{/packageName}/packages{/token}`,
    },
    addBundle: {
      method: 'POST',
      params: { action: 'add-aab' },
    },
    getGroup: {
      method: 'GET',
      url: `${apiPath}/apps{/packageName}/releases/group/`,
    },
    createGroup: {
      method: 'POST',
      url: `${apiPath}/apps{/packageName}/releases/group/`,
    },
    getGroupById: {
      method: 'GET',
      url: `${apiPath}/apps{/packageName}/releases/group{/id}/`,
    },
    getReleaseMemberByID: {
      method: 'GET',
      url: `${apiPath}/apps{/packageName}/releases/group{/id}/members/`,
    },
    updateGroup: {
      method: 'PATCH',
      url: `${apiPath}/apps{/packageName}/releases/group{/id}`,
    },
    removeGroup: {
      method: 'DELETE',
      params: { action: 'packages' },
      url: `${apiPath}/apps{/packageName}/releases/group{/id}`,
    },
    getGroupMembers: {
      method: 'GET',
      url: `${apiPath}/apps{/packageName}/releases/group{/id}/members/`,
    },
    removeGroupMember: {
      method: 'DELETE',
      url: `${apiPath}/apps{/packageName}/releases/group{/id}/remove-member/`,
    },
  },
);

export default Release;
